export default __webpack_public_path__ + "assets/ico_departure-d5a58466.svg";